import { render, staticRenderFns } from "./CardResellValue.vue?vue&type=template&id=197930bb&scoped=true&"
import script from "./CardResellValue.vue?vue&type=script&lang=js&"
export * from "./CardResellValue.vue?vue&type=script&lang=js&"
import style0 from "./CardResellValue.vue?vue&type=style&index=0&id=197930bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197930bb",
  null
  
)

export default component.exports